import { useFormContext } from "react-hook-form";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useState } from "react";
import CheckBoxLabelHookForm from "../../../../../components/CheckBoxLabelHookForm";
import { LicenseTypeInfo } from "../types";
import { useRecoilValue } from "recoil";
import { editStateLicenseType } from "../atoms/atoms";

const LicenseTypeDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: LicenseTypeInfo | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateLicenseType);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.licenseTypeName);
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="licenseTypeName"
                label="License Type Name"
                type="text"
                required={true}
                onChange={(e) => {
                  const value = e.target.value.trim();
                  setInputData(value);
                  if (
                    value.length === 0 ||
                    (value === data?.licenseTypeName &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                className={
                  formMethods.formState.errors.licenseTypeName &&
                  formMethods.formState.errors.licenseTypeName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("licenseTypeName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  type="checkbox"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  className={
                    formMethods.formState.errors.isActive &&
                    formMethods.formState.errors.isActive.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.length === 0 ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.licenseTypeName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LicenseTypeDetails;
